export const Color = {
  Blue: (opacity = 1) => `rgba(80, 102, 161, ${opacity})`,
  Watermelon: (opacity = 1) => `rgba(240, 113, 121, ${opacity})`,
  flatBlack: 'rgb(43, 43, 43)',
  flatBlue: 'rgb(80, 102, 161)',
  flatBrown: 'rgb(94, 69, 52)',
  flatCoffee: 'rgb(163, 134, 113)',
  flatForestGreen: 'rgb(52, 94, 65)',
  flatGray: 'rgb(149, 165, 166)',
  flatGreen: 'rgb(47, 204, 112)',
  flatLime: 'rgb(166, 199, 60)',
  flatMagenta: 'rgb(155, 89, 181)',
  flatMaroon: 'rgb(120, 48, 42)',
  flatMint: 'rgb(26, 189, 156)',
  flatNavyBlue: 'rgb(52, 73, 94)',
  flatOrange: 'rgb(229, 125, 34)',
  flatPink: 'rgb(245, 125, 197)',
  flatPlum: 'rgb(94, 52, 94)',
  flatPowderBlue: 'rgb(184, 202, 242)',
  flatPurple: 'rgb(116, 94, 196)',
  flatRed: 'rgb(232, 78, 60)',
  flatSand: 'rgb(240, 222, 180)',
  flatSkyBlue: 'rgb(53, 153, 219)',
  flatTeal: 'rgb(59, 112, 130)',
  flatWatermelon: 'rgb(240, 113, 121)',
  flatWhite: 'rgb(237, 241, 242)',
  flatYellow: 'rgb(255, 205, 3)',
  flatBlackDark: 'rgb(38, 38, 38)',
  flatBlueDark: 'rgb(57, 77, 130)',
  flatBrownDark: 'rgb(79, 58, 43)',
  flatCoffeeDark: 'rgb(143, 114, 94)',
  flatForestGreenDark: 'rgb(44, 79, 53)',
  flatGrayDark: 'rgb(126, 139, 140)',
  flatGreenDark: 'rgb(38, 173, 95)',
  flatLimeDark: 'rgb(143, 176, 33)',
  flatMagentaDark: 'rgb(142, 68, 173)',
  flatMaroonDark: 'rgb(102, 37, 33)',
  flatMintDark: 'rgb(22, 161, 133)',
  flatNavyBlueDark: 'rgb(43, 61, 79)',
  flatOrangeDark: 'rgb(212, 85, 0)',
  flatPinkDark: 'rgb(212, 91, 157)',
  flatPlumDark: 'rgb(79, 43, 79)',
  flatPowderBlueDark: 'rgb(154, 172, 214)',
  flatPurpleDark: 'rgb(92, 72, 163)',
  flatRedDark: 'rgb(191, 57, 42)',
  flatSandDark: 'rgb(214, 195, 150)',
  flatSkyBlueDark: 'rgb(41, 128, 186)',
  flatTealDark: 'rgb(53, 98, 115)',
  flatWatermelonDark: 'rgb(217, 85, 89)',
  flatWhiteDark: 'rgb(189, 195, 199)',
  flatYellowDark: 'rgb(255, 170, 0)',
  flatTransparent: 'rgba(255, 255, 255, 0)',

  panelColor: 'hsla(8, 44%, 64%, 0.1)',
  mainColor: '#6abdd2',
}